<template>
  <!--
  top/top-start/top-end/bottom/bottom-start/bottom-end/left/left-start/left-end/right/right-start/right-end
  -->
  <div v-if="enabled" class="shop-footer" @mouseover="pause" @mouseout="resume">
    <div class="notification-heading">
      <span v-text="currentHeading"></span>.
      <el-popover
          popper-class="notifications-popover"
          placement="top"
          visible-arrow="true"
          width="350"
          trigger="click">
        <div class="header">
          <h6 v-text="currentHeading"></h6>
          <a href="#" class="close bottom" @click="closePopover($event)">
            <i class="el-icon-circle-close"></i>
          </a>
        </div>
        <div class="content">
          <div class="details" v-html="currentMsg">
          </div>
        </div>
        <a slot="reference" href="#" @click="readMore($event)" v-text="res.home_more_txt+'...'"></a>
      </el-popover>
    </div>
    <!--
    <div class="close-btn">
      <a href="#" @click="close($event)"><i class="el-icon-error"></i></a>
    </div>
    -->
  </div>
</template>
<script>

import { bus } from './EshopNotificationsHeader';

export default {
  data: function() {
    var enabled = sessionStorage.getItem('notifications_enabled');
    return {
      notifications : [],
      notification : 0,
      res : $r,
      rotator : null,
      enabled : (enabled === 'true' || enabled == null ? true : false)
    }
  },
  computed: {
    currentHeading(){
      return this.notifications.length > 0 ? this.notifications[this.notification].heading : null;
    },

    currentMsg(){
      return this.notifications.length > 0 ? this.notifications[this.notification].details : null;
    },

    rotateInterval : function (){
      return this.res.hasOwnProperty('eshop_ntfctn_rotate_interval') ? parseInt(this.res.eshop_ntfctn_rotate_interval) : 10;
    }
  },
  methods : {
    closePopover(e_){
      e_.preventDefault();
      this.$children[0].doClose();
    },
    pause(){
      clearInterval(this.rotator);
    },
    resume(){
      this.start();
    },
    start(){
      var $this = this;
      this.rotator = setInterval(function (){
        $this.notification = ($this.notification + 1 >= $this.notifications.length ?  0 : $this.notification+1);
      }, this.rotateInterval*1000)
    },
    /*
    close(e_){
      e_.preventDefault();
      this.pause();
      sessionStorage.setItem('notifications_enabled', false);
      this.enabled = false;
    },
    */
    readMore(e_){
      e_.preventDefault();
    }
  },
  mounted(){
    if (this.enabled)
      this.start();

    var height = document.querySelector('footer').offsetHeight;
    var footer = document.querySelector('.shop-footer');
    var footer_is_sticky = false;

    setTimeout(function (){
      if ((document.body.scrollHeight) - window.pageYOffset - window.innerHeight - height >= 0) {
        footer.classList.add("sticky");
        footer_is_sticky = true
      }
    }, 1000);

    window.addEventListener('resize',  function (){
      if ((document.body.scrollHeight) - window.pageYOffset - window.innerHeight - height >= 0) {
        footer.classList.add("sticky");
        footer_is_sticky = true
      }
      else {
        footer_is_sticky = false;
        footer.classList.remove("sticky");
      }
    });

    window.addEventListener('scroll',function(e){
      if ((document.body.scrollHeight + (footer_is_sticky ? 50 : 0)) - window.pageYOffset - window.innerHeight - height >= 0) {
        footer.classList.add("sticky");
        footer_is_sticky = true
      }
      else {
        footer_is_sticky = false
        footer.classList.remove("sticky");
      }
    });
  },
  created (){
    bus.$on('getNotifications', (data) => {
      this.notifications = data;
    });
  }
}
</script>